import HomeTemplate from './HomeTemplate';

export default HomeTemplate;
